module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/leader-seminar/font/notokr-bold.woff
// module id = ALys
// module chunks = 0